import React, { useState } from 'react';
import { Row, Col, Select, Switch, Form } from 'antd';
import PropTypes from 'prop-types';

import { HOURS } from '../constants/Time';

export const getPharmacyId = () => {
	const pharmacyId = localStorage.getItem('PHARMACY_LOGGED');
	return pharmacyId;
};

export function ScheduleComponent({ day }) {
	const [isDisabled, setIsDisabled] = useState(false);
	const [isRequired, setIsRequired] = useState(false);

	const changeDisabledStatus = (status) => {
		setIsDisabled(status);
		setIsRequired(status);
	};

	return (
		<Row gutter={24}>
			<Col span={6} style={{ alignItems: 'flex-end', display: 'grid' }}>
				<Row gutter={14}>
					<Col span={8}>
						<Form.Item name={['days', day.value, 'status']}>
							<Switch
								checkedChildren={'On'}
								unCheckedChildren={'Off'}
								checked={isDisabled}
								onChange={() => changeDisabledStatus(!isDisabled)}
							/>
						</Form.Item>
					</Col>
					<Col span={6}>
						<span style={{ marginLeft: 10, marginTop: 3, fontWeight: '500', fontSize: 16 }}>{day.day}</span>
					</Col>
				</Row>
			</Col>
			<Col span={9}>
				<Form.Item
					label='Open'
					initialValue={0}
					name={['days', day.value, 'open']}
					rules={[
						{
							required: isRequired
						}
					]}
					style={{ width: '100%' }}
				>
					<Select disabled={!isDisabled}>
						{HOURS.map((hour) => (
							<Select.Option key={hour.id} value={hour.value}>
								{hour.hour}
							</Select.Option>
						))}
					</Select>
				</Form.Item>
			</Col>
			<Col span={9}>
				<Form.Item
					label='End'
					initialValue={0}
					name={['days', day.value, 'close']}
					rules={[
						{
							required: isRequired
						}
					]}
					style={{ width: '100%' }}
				>
					<Select disabled={!isDisabled}>
						{HOURS.map((hour) => (
							<Select.Option key={hour.id} value={hour.value}>
								{hour.hour}
							</Select.Option>
						))}
					</Select>
				</Form.Item>
			</Col>
		</Row>
	);
}

ScheduleComponent.propTypes = {
	day: PropTypes.object
};
